import { InvoiceForm } from "app/javascript/types/invoiceForm.type";

export function formDataToNestedJson(formData: FormData) {
  const json = {};

  Array.from(formData.entries()).forEach(([key, value]) => {
    const parts = key.replace(/\[/g, ".").replace(/\]/g, "").split(".");
    let current = json;

    // Handle array parameters FIRST
    if (parts[parts.length - 1] === "") {
      parts.pop();
      const arrayKey = parts.join(".");

      // Create nested objects if they don't exist
      const nestedParts = arrayKey.split(".");
      let nestedCurrent = json;
      nestedParts.forEach((part, index) => {
        if (index < nestedParts.length - 1) {
          if (!nestedCurrent[part]) {
            nestedCurrent[part] = {};
          }
          nestedCurrent = nestedCurrent[part];
        }
      });

      if (!nestedCurrent[nestedParts[nestedParts.length - 1]]) {
        nestedCurrent[nestedParts[nestedParts.length - 1]] = [];
      }
      nestedCurrent[nestedParts[nestedParts.length - 1]].push(value);
      return; // Important: exit early after handling the array
    }

    // Handle regular parameters
    parts.forEach((part, index) => {
      if (index === parts.length - 1) {
        current[part] = value;
      } else {
        const nextPart = parts[index + 1];
        if (!current[part]) {
          current[part] = /^\d+$/.test(nextPart) ? [] : {};
        }
        current = current[part];
      }
    });
  });

  return json;
}

export const getFormData = (selector) => {
  const form: HTMLFormElement = document.querySelector(selector);
  const formData = new FormData(form);

  return formDataToNestedJson(formData) as InvoiceForm;
}
